import axios from "axios";
import { localStorageItem } from './../../../../utils/LocalStorage';
import { KEY_LOCALSTORAGE } from "../../../../auth/core/_consts";

const API = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"] || process.env.REACT_APP_WMS_API_URL;
const API_KE_HOACH = API + "/tech-transfer-info";

export const addPhieuKeHoach = (data: any) => {
  let url = API_KE_HOACH;
  return axios.post(url, data);
};
export const updatePhieuKeHoach = (id: string, data: any) => {
  let url = API_KE_HOACH + `/${id}`;
  return axios.put(url, data);
};

export const searchPhieuKeHoach = (searchData: any) => {
  const url = `${API}` + `/tech-transfer-info/search`;
  return axios.post(url, searchData);
};

export const deletePhieuKeHoach = (trackerCode: string, id: string) => {
  const url = `${API_KE_HOACH}` + `/${trackerCode}/${id}`;
  return axios.delete(url);
};

export const searchdsDot = (techTransferInfoId: string | undefined) => {
  var url = API + `/tech-transfer-batch/by-info/${techTransferInfoId}`
  return axios.get(url)
}

export const saveDot = (id: string, payload: any) => {
  const url = `${API}` + `/tech-transfer-batch/${id}`;
  return axios.put(url, payload);
};

export const searchdsCanBo = (id: string | undefined) => {
  var url = API + `/plan/get-staff-by-slip-id/${id}`
  return axios.get(url)
}

export const searchdsNhanSu = (id: string | undefined) => {
  var url = API + `/tech-transfer-batch-staff/by-tech-transfer-info/${id}`
  return axios.get(url)
}
